import 'core-js';
// import utils from './utils';

const Zion = (name, url) => {
  const detectEnvironment = () => {
    // const url = window.location.href;
    if (url.indexOf('ix.cnn.io') > 0 || url.indexOf('www.cnn.com') > 0 || url.indexOf('edition.cnn.com') > 0) {
      return 'Prod';
    }
    if (
      url.indexOf('cnnpreview') > 0
            || url.indexOf('cnn-interactive') > 0
            || url.indexOf('ix-cnn-io-stage') > 0
    ) {
      return 'Stage';
    }
    return 'Dev';
  };

  // const isMobileDevice = utils.mobileAndTabletCheck();
  // const isMobile = window.innerWidth < 800 || isMobileDevice;
  const zionEnv = detectEnvironment();
  console.log('zionEnv', zionEnv);

  const zionConfigUrl = 'https://z.cdp-dev.cnn.com/zion-web-client/3.0/';
  // this does the async load of the sdk
  const d = document;
  const g = d.createElement('script');
  const s = d.getElementsByTagName('script')[0];
  g.type = 'text/javascript';
  g.defer = true;
  g.async = true;
  g.src = `${zionConfigUrl}zion-web-client.min.js`;
  s.parentNode.insertBefore(g, s);
  // wait for the sdk to be loaded to setup things
  g.onload = () => {
    // create a handle for the zion analytics object
    window.zion_analytics.configure({
      appId: 'cnn.com', // fallback to cnn.com
      bridgeEnabled: true,
      // enableLogging: true,
      platform: 'web',
      telemetryEndpoint: '//zion-telemetry-nonprod.api.cnn.io/',
      trackUxMetrics: true,
      uxMetricsPercentage: 100,
      environment: window.ZION_SDK.EnvironmentType.InternalDev,
    });
    window.zion_analytics.track(
      new window.ZION_SDK.Pageview({
        // contact data core if your not sure what values to use
        sourceId: `graphic_${name}`,
        hypatiaId: 'h_1',
        canonicalUrl: url,
      }),
    );
  };
};

export default Zion;
